/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../../../services/vehicle/vehicle_interfaces.ts"/>

module DealerwareWebComponents {
    "use strict";

    export class VehicleTollHistoryDirectiveController {
        public static $inject: string[] = [
            '$scope',
            '$filter',
            '$mdMedia',
            '$mdDialog',
            'DataUtils',
            '$mobilityCompanyAuthentication',
            '$dealerwareLoading',
            '$dealerwareNotification',
            '$dealerwareInternationalizationDateFormats'
        ];

        public vehicle: any;
        public tollColumns: any;
        public loader: any;

        constructor(
                public $scope: any,
                public $filter: any,
                public $mdMedia: any,
                public $mdDialog: any,
                public DataUtils: any,
                public $mobilityCompanyAuthentication: any,
                public $dealerwareLoading: any,
                public $dealerwareNotification: any,
                public $dealerwareInternationalizationDateFormats: any) {
            this.initTollColumns();
        }

        public pageTransitionError(response : any) : void {
            this.loader.close();
            this.$dealerwareNotification.apiError(response);
        }

        public get useFullScreen() {
            return this.$mdMedia('xs') || this.$mdMedia('sm');
        }

        public initTollColumns() : void {
            var _self = this,
                time_zone = this.$mobilityCompanyAuthentication.location.time_zone_name;

            this.tollColumns = [{
                key: 'id',
                hidden: true
            },{
                key: 'tolled_at',
                header: 'Timestamp',
                dataFilter: (ts: string) => {
                    return ts ? this.$filter('filterInternationalizationDate')(this.DataUtils.getInstance().formatTimestampSimple(ts, time_zone)) : '';
                }
            },{
                key: 'description',
                header: 'Description'
            },{
                key: 'value',
                header: 'Amount',
                dataFilter: function(v: string) { return '$' + parseFloat(v).toFixed(2); }
            }];
        }

        public loadTollHistory() : void {
            var _self = this;

            var loader = this.$dealerwareLoading.show('Loading...');
            this.vehicle.loadTollHistory().then().finally(
                function() { loader.close(); }
            );
        }

        public get addTollController() {
            var _self = this;

            return function($scope: any, $mdDialog: any, vehicle: any, DealerwareTollModel: any, $dealerwareInternationalizationDateFormats: any) {
                $scope.toll = new DealerwareTollModel({});
                $scope.internationalization = $dealerwareInternationalizationDateFormats.datePickerFormat();
                $scope.availableTimes = $dealerwareInternationalizationDateFormats.getAvailablesTimesFormat();

                $scope.cancel = function() : void {
                    $mdDialog.hide();
                };

                $scope.updateTolledAt = function() : void {
                    if ($scope.date && $scope.time) {
                        var d = $scope.date,
                            t = $scope.time.split(':');

                        $scope.toll.data.tolled_at = moment([d.getFullYear(), d.getMonth(), d.getDate(), t[0], t[1]]).format();
                    }
                };

                $scope.addToll = function() : void {
                    $scope.toll.$create({
                        promise: true,
                        params: {
                            location_id: vehicle.locationId,
                            vehicle_id: vehicle.vehicleId
                        }
                    }).then(
                        function(returnValue: any) {
                            $mdDialog.hide();
                            _self.loadTollHistory();
                        },
                        function(response: any) { _self.$dealerwareNotification.apiError(response); }
                    );
                };
            };
        }

        public openAddTollModal() {
            this.$mdDialog.show({
                templateUrl: '/components/vehicle/tolls/add_toll_modal.html',
                controller: this.addTollController,
                locals: { vehicle: this.vehicle },
                clickOutsideToClose: false,
                fullScreen: this.useFullScreen
            });
        }
    }

    getDealerwareWebComponentsModule().controller('VehicleTollHistoryDirectiveController', VehicleTollHistoryDirectiveController);

    export class VehicleTollHistoryDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'VehicleTollHistoryDirectiveController';
        public controllerAs     : string    =   'tollHistoryController';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public scope            : Object    =   {vehicle: '='};
        public transclude       : boolean   =   false;
        public templateUrl      : string    =   '/components/vehicle/tolls/toll_history_directive.html';
        public static $inject   : string[]  =   [];

        constructor() {}

        public link : ng.IDirectiveLinkFn = (
            scope   :   any,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {}
    }

    // register the directive
    getDealerwareWebComponentsModule().directive("dealerwareVehicleTollHistory",() => new VehicleTollHistoryDirective());
 }
